import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

export interface ISupportTicketDetail {
    id: number;
    user: {
        id: number;
        email: string;
        first_name: string | null;
        last_name: string | null;
    };
    subject: string;
    category: string;
    message: string;
    pair_name: string;
    tracking_id: string;
    status: "open" | "in_progress" | "resolved" | "closed";
    status_display: string;
    priority: "low" | "medium" | "high" | "not_set";
    priority_display: string;
    admin_remarks: string | null;
    created_at: string;
    updated_at: string;
    resolved_at: string | null;
}

import { IPagination } from "../../interfaces";

export interface ISupportTicketsResponse extends IPagination {
    results: ISupportTicketDetail[];
}

interface ISupportTicketsParams {
    page?: number;
    per_page?: number;
    status?: string;
    category?: string;
    user_id?: number;
    tracking_id?: string;
}

export const useSupportTickets = (params: ISupportTicketsParams = {}) => {
    return useQuery<ISupportTicketsResponse, Error>({
        queryKey: ["support-tickets", params],
        queryFn: async () => {
            const response = await httpService.get<ISupportTicketsResponse>(
                `${API_CONFIG.path.supportTickets}/list`,
                params as any
            );
            return response;
        },
    });
};
